import React from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";

const FastResponseEmail: React.FC = () => {

  return (
    <div>
      <h2>Alerta via email - Fast Response</h2>
      <div className="grid">
        <div className="col-12">
          <div className="grid">
            <div className="col-12">
              <label
                className={`text-sm`}
              >
                Destinatário: 
              </label>
                <InputText
                  maxLength={500}
                  className="w-full"
                  tabIndex={0}
                />
            </div>
            <div className="col-12">
              <label
                className={`text-sm`}
              >
                Título: 
              </label>
                <InputText
                  maxLength={500}
                  className="w-full"
                  tabIndex={0}
                />
            </div>
            <div className="col-12">
              <label
                className={`text-sm`}
              >
                Conteúdo: 
              </label>
                <InputTextarea
                  rows={12}
                  maxLength={500}
                  className="w-full"
                  tabIndex={0}
                />
            </div>

        <div className="col-12 flex justify-between mt-4">
          <Button
            type="button"
            label="Cancelar"
            className="p-button-danger"
          />
          <div className="ml-auto">
            <Button
              type="submit"
              label="Registrar"
              className="p-button-success gap-2"
              icon="pi pi-check"
            />
          </div>
        </div>
      </div>
      <ConfirmDialog />
    </div>
    </div>
    </div>
  );
};

export default FastResponseEmail;
